function ContentPillarsEditor({ contentPillars, addContentPillar, removeContentPillar, updateContentPillar }) {
  return (
    <div style={{
      background: '#111118', padding: '32px',
      borderRadius: '12px', border: '1px solid #282839'
    }}>
      <div style={{ borderBottom: '1px solid #282839', paddingBottom: '16px', marginBottom: '24px' }}>
        <h4 style={{ fontSize: '18px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ color: '#1313ec' }}>&#128203;</span>
          콘텐츠 필러 (Monthly Themes)
        </h4>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
        {contentPillars.map((pillar, index) => (
          <div key={index} style={{
            padding: '20px', background: '#1c1c27',
            borderRadius: '12px', border: '1px solid #3b3b54'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
              <span style={{
                padding: '4px 8px', background: '#1313ec', color: 'white',
                fontSize: '10px', fontWeight: '700', borderRadius: '4px', textTransform: 'uppercase'
              }}>
                Theme {index + 1}
              </span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <select
                  value={pillar.frequency}
                  onChange={(e) => updateContentPillar(index, 'frequency', e.target.value)}
                  style={{
                    fontSize: '12px', background: 'transparent', border: 'none',
                    color: '#9d9db9', outline: 'none'
                  }}
                >
                  <option value="매주 월요일">매주 월요일</option>
                  <option value="매주 화요일">매주 화요일</option>
                  <option value="매주 수요일">매주 수요일</option>
                  <option value="매주 목요일">매주 목요일</option>
                  <option value="매주 금요일">매주 금요일</option>
                  <option value="주 1회">주 1회</option>
                  <option value="주 2회">주 2회</option>
                </select>
                <button
                  onClick={() => removeContentPillar(index)}
                  style={{
                    background: 'none', border: 'none', cursor: 'pointer',
                    color: '#ef4444', fontSize: '16px', padding: 0
                  }}
                >
                  ✕
                </button>
              </div>
            </div>
            <input
              type="text"
              value={pillar.title}
              onChange={(e) => updateContentPillar(index, 'title', e.target.value)}
              placeholder="주제 입력 (예: 신메뉴 소개)"
              style={{
                width: '100%', background: 'transparent',
                borderBottom: '1px solid #3b3b54', border: 'none',
                borderBottomWidth: '1px', borderBottomStyle: 'solid', borderBottomColor: '#3b3b54',
                paddingBottom: '8px', fontSize: '14px', fontWeight: '700',
                outline: 'none', marginBottom: '8px'
              }}
            />
            <textarea
              value={pillar.description}
              onChange={(e) => updateContentPillar(index, 'description', e.target.value)}
              placeholder="간략한 설명..."
              style={{
                width: '100%', background: 'transparent', border: 'none',
                fontSize: '12px', color: '#9d9db9', outline: 'none',
                resize: 'none', height: '48px'
              }}
            />
          </div>
        ))}

        {/* 새 테마 추가 버튼 */}
        <div
          onClick={addContentPillar}
          style={{
            padding: '20px', border: '2px dashed #3b3b54', borderRadius: '12px',
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center', gap: '8px', cursor: 'pointer',
            minHeight: '120px', transition: 'all 0.2s'
          }}
        >
          <span style={{ color: '#9d9db9', fontSize: '24px' }}>+</span>
          <span style={{ fontSize: '12px', color: '#9d9db9', fontWeight: '700' }}>새 테마 추가</span>
        </div>
      </div>
    </div>
  );
}

export default ContentPillarsEditor;
